import {ViewType} from "./view_type";
import {ISetViewTypeAction, IViewTypeMetaData, SET_VIEW_TYPE} from "./view_type_actions";

export interface IViewTypeStore {
    current: ViewType | null;
    currentData: Partial<IViewTypeMetaData>;
    previous: ViewType | null;
}

const initialState: IViewTypeStore = {
    current: null,
    currentData: {},
    previous: null
};

export const viewTypeReducer = (state: IViewTypeStore = initialState, action: ISetViewTypeAction): IViewTypeStore => {
    switch (action.type) {
        case SET_VIEW_TYPE:
            return {
                current: action.current,
                currentData: action.data,
                previous: state.current
            };
        default:
            return state;
    }
};
